import { render, staticRenderFns } from "./NavButtons.vue?vue&type=template&id=0f7c5c6d&scoped=true"
import script from "./NavButtons.vue?vue&type=script&lang=js"
export * from "./NavButtons.vue?vue&type=script&lang=js"
import style0 from "./NavButtons.vue?vue&type=style&index=0&id=0f7c5c6d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7c5c6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1708/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f7c5c6d')) {
      api.createRecord('0f7c5c6d', component.options)
    } else {
      api.reload('0f7c5c6d', component.options)
    }
    module.hot.accept("./NavButtons.vue?vue&type=template&id=0f7c5c6d&scoped=true", function () {
      api.rerender('0f7c5c6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/components-combo/NavButtons.vue"
export default component.exports